module.exports = __webpack_public_path__ + "img/Disk.114b8c33.png";